import { api } from './api';

export interface ActiveRide {
  id: number;
  status: string;
  type?: string | null;
  riderId: string;
  driverId?: string | null;
  pickupLocation?: string;
  dropoffLocation?: string;
  pickupCity?: string | null;
  dropoffCity?: string | null;
  requestedAt: string;
  matchedAt?: string | null;
  startedAt?: string | null;
  fare?: number | null;
  totalFare?: number | null;
  rider?: { name?: string | null; phone?: string | null } | null;
  driver?: { name?: string | null; phone?: string | null } | null;
}

/** Read-only live monitor of in-flight rides. */
export const getActiveRides = (): Promise<{ data: ActiveRide[] }> =>
  api.get('/admin/live/active-rides').then((r) => r.data);
